export const LANGUAGE_ENGLISH = 'en';
export const LANGUAGE_FRENCH = 'fr';
export const LANGUAGE_DUTCH = 'nl';
export const LANGUAGE_CROATIAN = 'hr';